import { useNavigate } from 'react-router-dom'
import {
    RiPriceTag3Line,
    RiRulerLine,
    RiMoneyDollarCircleLine,
    RiShoppingCartLine,
    RiTruckLine,
    RiArrowRightLine,
} from 'react-icons/ri'
import { useAdminOrders } from '@/api/useAdminOrders'
import { useAdminMaterials, useAdminSizes, useAdminPrices, useAdminShipping } from '@/api/useAdminCatalog'
import { Spinner } from '@/components/ui'
import { ROUTES } from '@/constants/routes'
import styles from './Dashboard.module.css'

export function Dashboard() {
    const navigate = useNavigate()
    const { data: ordersData, isLoading: loadingOrders } = useAdminOrders()
    const { data: materials } = useAdminMaterials()
    const { data: sizes } = useAdminSizes()
    const { data: prices } = useAdminPrices()
    const { data: shipping } = useAdminShipping()

    const orders = ordersData?.orders ?? []
    const totalOrderCount = ordersData?.count ?? 0

    const pendingOrders = orders.filter((o) => o.status === 'pending').length
    const confirmedOrders = orders.filter((o) => o.status === 'confirmed').length
    const printingOrders = orders.filter((o) => o.status === 'printing').length
    const shippedOrders = orders.filter((o) => o.status === 'shipped').length

    const stats = [
        { label: 'Pedidos pendientes', value: pendingOrders, color: 'warning' as const },
        { label: 'Confirmados', value: confirmedOrders, color: 'info' as const },
        { label: 'En impresión', value: printingOrders, color: 'primary' as const },
        { label: 'Enviados', value: shippedOrders, color: 'success' as const },
    ]

    const catalogCards = [
        { label: 'Materiales', count: materials?.length ?? 0, icon: RiPriceTag3Line, path: ROUTES.adminMaterials },
        { label: 'Tamaños', count: sizes?.length ?? 0, icon: RiRulerLine, path: ROUTES.adminSizes },
        { label: 'Precios', count: prices?.length ?? 0, icon: RiMoneyDollarCircleLine, path: ROUTES.adminPrices },
        { label: 'Envíos', count: shipping?.length ?? 0, icon: RiTruckLine, path: ROUTES.adminShipping },
    ]

    if (loadingOrders) {
        return (
            <div className={styles.loading}>
                <Spinner size="lg" />
            </div>
        )
    }

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Dashboard</h1>

            {/* Order stats */}
            <section className={styles.section}>
                <div className={styles.sectionHeader}>
                    <h2 className={styles.sectionTitle}>Pedidos</h2>
                    <button className={styles.viewAllBtn} onClick={() => navigate(ROUTES.adminOrders)}>
                        Ver todos <RiArrowRightLine />
                    </button>
                </div>
                <div className={styles.statsGrid}>
                    {stats.map((s) => (
                        <div key={s.label} className={`${styles.statCard} ${styles[s.color]}`}>
                            <span className={styles.statValue}>{s.value}</span>
                            <span className={styles.statLabel}>{s.label}</span>
                        </div>
                    ))}
                </div>
                <p className={styles.totalOrders}>
                    <RiShoppingCartLine /> {totalOrderCount} pedidos en total
                </p>
            </section>

            {/* Catalog summary */}
            <section className={styles.section}>
                <div className={styles.sectionHeader}>
                    <h2 className={styles.sectionTitle}>Catálogo</h2>
                </div>
                <div className={styles.catalogGrid}>
                    {catalogCards.map((c) => (
                        <button
                            key={c.label}
                            className={styles.catalogCard}
                            onClick={() => navigate(c.path)}
                        >
                            <c.icon className={styles.catalogIcon} />
                            <span className={styles.catalogCount}>{c.count}</span>
                            <span className={styles.catalogLabel}>{c.label}</span>
                        </button>
                    ))}
                </div>
            </section>
        </div>
    )
}
